import { AttivitaReale } from '../didattica/attivita-reale';
import { Docente } from '../didattica/docente';
import { Delega } from './delega';
import { RichiestaDiConferma } from './richiesta-conferma';

/**
 * la classe di modello della rilevazione
 */
export interface Rilevazione {
// per la chiave completa aggiungere il tenant
id: any;
idAttivitaReale: any;
idDelega?: any;

// informazioni sul docente
idDocente: any;

// il codice generato per la rilevazione
iul: string;
stato?: StatoRilevazione;

// modalità di erogazione della rilevazione (in presenza, da remoto, ibrida)
modalitaErogazione?: ModalitaErogazione;

// tipo di lezione (LEZ	Lezione, ESE	Esercitazione, SEM	Seminario, TIR	Tirocinio, LAB	Laboratorio , ....)
tipoAttivita?: string;
tipoAttivitaDesc?: string;

// durata in minuti
durata?: number;

// durata prevista formattata
durataF?: string;

// durata reale in minuti, considerando quindi la chiusura anticipata
durataReale?: number;

// durata reale formattata
durataRealeF?: string;

// quando è stata creata la rilevazione
istanteCreazione?: Date;

// presente sul db
chiusuraAnticipata?: Date;
// istanteGenerazioneNumero?: Date;

// campo calcolato
chiusura?: Date;

// luogo in cui il numero è stato generato
latitudine?: number;
longitudine?: number;

docente?: Docente;
ar?: AttivitaReale;

numeroPresenze?: number;

// la rilevazione prevede una prenotazione?
prenotazione?: StatoPrenotazione;

/**
 * Indirizzo della rilevazione
 * E' diventato un dato persistente in modo da non doverlo ricalcolare ogni volta
 */
address?: string;

/**
 * Serve ad appoggiare il dato della distanza dello studente dalla rilevazione
 * in fase di presentazione delle IUL tramite il radar rilevazioni
 */
distanceFromStudent?: number;

/**
 * Eventuale delega associata alla rilevazione
 */
delega?: Delega;

/**
 * Eventuale richiesta di conferma associata alla rilevazione
 */
richiestaConferma?: RichiestaDiConferma;

/**
 * Eventuale delegato alla rilevazione
 */
delegato?: Docente;

/**
 * Campi per integrazione con Registro docente
 */
remoteStartDateTime?: Date;

remoteDurata?: number;

note?: string;

idPta?: string;

pta?: string;

ptaIstanteCreazione?: Date;

// utilizzato per comunicare l bff che la ril verrà creata sull'anno accdemico precedente
usePreviousYear?: boolean;
/**
 * Ritorna la descrizione principale da mostrare a video
 */
titolo?: () => string;

/**
 * Ritorna informazioni di dettaglio da mostrare a video
 */
sottoTitolo?: () => string;

/**
 * Ritorna true se la rilevazione è conclusa
 */
conclusa?: () => boolean;

/**
 * Restituisce il delegato
 */
docenteDelegato?: () => string;
}



export enum StatoRilevazione {
    IN_CORSO= 'IN_CORSO',
    IN_RITARDO= 'IN_RITARDO',
    CONCLUSA= 'CONCLUSA',
    IN_PROGRAMMA= 'IN_PROGRAMMA'
}

export enum StatoPrenotazione {
    PREVISTA = 'PREVISTA',
    NONPREVISTA = 'NONPREVISTA',
    NONRECUPERATA = 'NONRECUPERATA',
    FACOLTATIVA = 'FACOLTATIVA'
}

export enum ModalitaErogazione {
    IN_PRESENZA = 'IN_PRESENZA',
    IBRIDA = 'IBRIDA',
    DA_REMOTO = 'DA_REMOTO'
}
